(function(angular) {
  'use strict';

  angular.module('Common')
  .factory('sweetAlertService',
      [function () {
      var fac = {
        confirmationAlert: function(title, text, confirmationText, cancleText, callback){
            swal({   
                title: title,   
                text: text,
                type: "warning",   
                showCancelButton: true,   
                confirmButtonText: confirmationText,
                cancelButtonText: cancleText,   
            }, function(isConfirm) {
                callback(isConfirm);
            });
        },
        inputAlert: function(title, text, confirmationText, cancleText, requestedValue, errorMessage, callback){
            swal({   
                title: title,   
                text: text,
                type: "input",
                showCancelButton: true,  
                closeOnConfirm: false, 
                confirmButtonText: confirmationText,
                cancelButtonText: cancleText,   
            }, function(inputValue) {
                if (inputValue === false) return false;

                else if (inputValue === "") {
                    swal.showInputError("You need to write something!");
                    return false;
                }
                else if (inputValue !== requestedValue){
                    swal.showInputError(errorMessage);
                    return false;
                }
                else {
                    callback(inputValue);
                }
            });
        }
      };

      return fac;
    }]);

})(window.angular);
